import React from 'react';
import styles from './notification.module.scss';
import clsx from 'clsx';
interface INotification {
  message?: string;
  type: string;
  dataTestId?: string;
  customClasses?: {containerStyle?:string, errorMessageStyle?: string};
}
export default function Notification({ message, type, dataTestId, customClasses}: INotification) {
  return (
    <div data-testid={dataTestId} className={clsx(customClasses?.containerStyle, styles.notification, styles[type])}>
      <p className={clsx(styles.message, customClasses?.errorMessageStyle)} role="alert">
        {message}
      </p>
    </div>
  );
}

